import { VStack } from '@chakra-ui/react';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useSelectorAssignAndReviewPromoVideoUrl } from '../../../../../configuration';
import { closeModal } from '../../../modal-manager';
import { VideoPlayer } from '../../../video-player/video-player';
import { AssignReviewPromoVideoWrapper } from './assign-review-promo-video-modal.styled';

export function AssignReviewVideoModal () {
    const dispatch = useDispatch();
    const assignReviewPromoVideoUrl = useSelectorAssignAndReviewPromoVideoUrl();

    return (
        <AssignReviewPromoVideoWrapper>
            <VStack
                spacing={0}
                align={'center'}
                textAlign={'center'}
                h={'602px'}
                w={'993px'}
                mb={0}
            >
                <VideoPlayer
                    onClose={() => dispatch(closeModal())}
                    src={assignReviewPromoVideoUrl}
                    title={'assign and review promo video'}
                />
            </VStack>
        </AssignReviewPromoVideoWrapper>
    );
}

